(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════
     SWIPER SELF-LOADER
     Loads Swiper CSS + JS from CDN if the theme does not
     already provide it. Prevents duplicate loading via
     data attributes on the injected elements.
  ════════════════════════════════════════════════════════ */
  var SWIPER_VERSION = '11';
  var SWIPER_JS_CDN = 'https://cdn.jsdelivr.net/npm/swiper@' + SWIPER_VERSION + '/swiper-bundle.min.js';

  function loadSwiper(callback) {
    /* Already available — nothing to load */
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    /* ── Inject Swiper JS only (once) ──────────────────────────────────────
       We do NOT load swiper-bundle.min.css from CDN because it adds global
       styles (.swiper, .swiper-wrapper, .swiper-slide …) that affect every
       carousel on the page.  All layout styles Swiper needs are already
       provided by video-reviews.css, scoped to .vr-section / .vr-swiper.
    ──────────────────────────────────────────────────────────────────────── */
    if (!document.querySelector('script[data-vr-swiper-js]')) {
      var script = document.createElement('script');
      script.src = SWIPER_JS_CDN;
      script.setAttribute('data-vr-swiper-js', '');
      script.onload = function () { callback(); };
      script.onerror = function () {
        console.warn('[Video Reviews] Swiper CDN load failed — carousel disabled.');
      };
      document.head.appendChild(script);
    } else {
      /* Script tag exists but Swiper object not ready yet — poll */
      var poll = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          clearInterval(poll);
          callback();
        }
      }, 60);
    }
  }

  /* ════════════════════════════════════════════════════════
     SECTION INIT
  ════════════════════════════════════════════════════════ */
  function initAllSections() {
    document.querySelectorAll('.vr-section').forEach(function (section) {
      initSection(section);
    });
  }

  function initSection(section) {
    if (section.classList.contains('vr-initialized')) return;
    section.classList.add('vr-initialized');

    var sectionId = section.dataset.sectionId;

    var options = {
      showArrows: section.dataset.showArrows === 'true',
      showPagination: section.dataset.showPagination === 'true',
      autoplayVideos: section.dataset.autoplay === 'true',
      slidesDesktop: parseFloat(section.dataset.slidesDesktop) || 4,
      slidesTablet: parseFloat(section.dataset.slidesTablet) || 3,
      slidesMobile: parseFloat(section.dataset.slidesMobile) || 1.2,
      spaceBetween: parseInt(section.dataset.spaceBetween, 10) || 16,
      loop: section.dataset.loop === 'true',
      autoplayCarousel: section.dataset.autoplayCarousel === 'true',
      autoplaySpeed: parseInt(section.dataset.autoplaySpeed, 10) || 5
    };

    loadSwiper(function () {
      initSwiper(section, sectionId, options);
      initCards(section, options);
    });
  }

  /* ════════════════════════════════════════════════════════
     SWIPER INIT
  ════════════════════════════════════════════════════════ */
  function initSwiper(section, sectionId, options) {
    var el = section.querySelector('#vr-swiper-' + sectionId);
    if (!el) { console.warn('[Video Reviews] Swiper element not found for section ' + sectionId); return; }

    /* Destroy stale instance (editor reloads) */
    if (el._swiperInstance) {
      el._swiperInstance.destroy(true, true);
      el._swiperInstance = null;
    }

    var navConfig = options.showArrows ? {
      nextEl: section.querySelector('.vr-arrow-next'),
      prevEl: section.querySelector('.vr-arrow-prev')
    } : false;

    var pageConfig = options.showPagination ? {
      el: section.querySelector('.vr-pagination'),
      clickable: true
    } : false;

    var autoplayConfig = options.autoplayCarousel ? {
      delay: options.autoplaySpeed * 1000,
      disableOnInteraction: false,  /* We manage stop/start manually */
      pauseOnMouseEnter: false       /* We manage hover manually */
    } : false;

    /* ---------- Swiper instance ---------- */
    el._swiperInstance = new Swiper(el, {
      /* Base = mobile */
      slidesPerView: options.slidesMobile,
      spaceBetween: options.spaceBetween,
      loop: options.loop,
      grabCursor: true,
      watchSlidesProgress: true,
      centeredSlides: false,
      autoplay: autoplayConfig,

      /* Responsive breakpoints */
      breakpoints: {
        /* Tablet ≥ 768 → 3 slides */
        768: {
          slidesPerView: options.slidesTablet,
          spaceBetween: options.spaceBetween
        },
        /* Desktop ≥ 1200 → 4 slides */
        1200: {
          slidesPerView: options.slidesDesktop,
          spaceBetween: options.spaceBetween
        }
      },

      navigation: navConfig,
      pagination: pageConfig
    });

    /* ══════════════════════════════════════════════════════════════════════
       MANUAL AUTOPLAY CONTROL
       We handle BOTH hover and touch/drag ourselves so the two signals
       never conflict with each other.

       Rules:
         • Hover  (mouseenter) → stop immediately, cancel any pending resume.
                  (mouseleave)  → schedule resume after HOVER_RESUME ms.
         • Touch / drag        → stop immediately.
                  (touchEnd)   → schedule resume after TOUCH_RESUME ms.
         • Arrow click         → schedule resume after TOUCH_RESUME ms.
         • If hover is still active when the touch resume timer fires,
           the resume is skipped — hover takes priority.
    ══════════════════════════════════════════════════════════════════════ */
    if (options.autoplayCarousel) {
      var resumeTimer  = null;
      var isHovered    = false;
      var TOUCH_RESUME = 4000;  /* ms idle after drag/arrow before resume   */
      var HOVER_RESUME = 1500;  /* ms after mouse-leave before resume        */

      function stopAutoplay() {
        clearTimeout(resumeTimer);
        var swiper = el._swiperInstance;
        if (swiper && swiper.autoplay && swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      }

      function scheduleResume(delay) {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          if (isHovered) return; /* hover still active — don't resume yet */
          var swiper = el._swiperInstance;
          if (swiper && swiper.autoplay) {
            swiper.autoplay.start(); /* always call — no-op if already running */
          }
        }, delay);
      }

      /* ── Hover ── */
      el.addEventListener('mouseenter', function () {
        isHovered = true;
        stopAutoplay();
      });
      el.addEventListener('mouseleave', function () {
        isHovered = false;
        scheduleResume(HOVER_RESUME);
      });

      /* ── Touch / Drag ── */
      el._swiperInstance.on('touchStart', function () {
        stopAutoplay();
      });
      el._swiperInstance.on('touchEnd', function () {
        scheduleResume(TOUCH_RESUME);
      });

      /* ── Arrow buttons ── */
      el._swiperInstance.on('navigationNext', function () { scheduleResume(TOUCH_RESUME); });
      el._swiperInstance.on('navigationPrev', function () { scheduleResume(TOUCH_RESUME); });
    }

    console.log('[Video Reviews] Swiper ready — section ' + sectionId +
      ' | desktop:' + options.slidesDesktop +
      ' | tablet:' + options.slidesTablet +
      ' | mobile:' + options.slidesMobile +
      ' | autoplay:' + options.autoplayCarousel +
      ' | speed:' + options.autoplaySpeed);
  }

  /* ════════════════════════════════════════════════════════
     CARDS
  ════════════════════════════════════════════════════════ */
  function initCards(section, options) {
    section.querySelectorAll('.vr-card').forEach(function (card) {
      initPlayBtn(card);
      initExpandBtn(card);
      initPanelClose(card);
      initVariants(card);
      initAddToCart(card);
      initMiniSearch(card);
    });
  }
  /* ── Shared IntersectionObserver for all videos ──────────────────────────
     rootMargin '500px' preloads videos well before they scroll into view so
     they are already buffered when the user reaches them — no stutter.
  ────────────────────────────────────────────────────────────────────────── */
  var videoObserver = null;
  if ('IntersectionObserver' in window) {
    videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var card  = entry.target;
        var video = card.querySelector('.vr-video');
        if (!video) return;

        if (entry.isIntersecting) {
          /* ── Lazy-load: set src once, never call .load() again ──────────
             Calling video.load() resets the decoder and causes the 1-2 s
             freeze. Setting .src directly lets the browser fetch + decode
             in the background without a full reset.
          ────────────────────────────────────────────────────────────────── */
          if (video.dataset.src) {
            video.src = video.dataset.src;
            video.removeAttribute('data-src');
            /* video.load() is required here: the liquid renders <video preload="none"
               data-src="..."> with NO src attribute. Without load(), the browser
               never sends an HTTP request and the video stays black.
               The lag was not from load() itself but from calling play() before
               the buffer was ready — that is now fixed by waiting for canplay. */
            video.load();
          }

          /* Wait until the browser has buffered enough to play smoothly */
          function tryPlay() {
            var promise = video.play();
            if (promise !== undefined) {
              promise.then(function () {
                card.classList.add('is-playing');
              }).catch(function () {
                card.classList.remove('is-playing');
              });
            } else {
              card.classList.add('is-playing');
            }
          }

          /* If ready to play immediately — go; otherwise wait for canplay */
          if (video.readyState >= 3) { /* HAVE_FUTURE_DATA */
            tryPlay();
          } else {
            video.addEventListener('canplay', tryPlay, { once: true });
          }

        } else {
          /* Slide scrolled out — pause and remove any pending canplay handler */
          if (!video.paused) video.pause();
        }
      });
    }, { rootMargin: '500px' }); /* preload 500 px before viewport edge */
  }

  /* ── Lazy load + IntersectionObserver for video performance ── */
  function initPlayBtn(card) {
    var video = card.querySelector('.vr-video');
    var audioBtn = card.querySelector('.vr-audio-btn');

    if (!video) return;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;

    function markPlaying() {
      card.classList.add('is-playing');
    }

    function markPaused() {
      card.classList.remove('is-playing');
    }

    if (videoObserver) {
      videoObserver.observe(card);
    } else {
      /* Fallback (no IntersectionObserver) — set src and load, then wait for canplay */
      if (video.dataset.src) {
        video.src = video.dataset.src;
        video.removeAttribute('data-src');
        video.load(); /* required: liquid renders <video preload="none" data-src="..."> */
      }
      if (video.readyState >= 3) {
        var p = video.play();
        if (p !== undefined) p.then(markPlaying).catch(markPaused);
        else markPlaying();
      } else {
        video.addEventListener('canplay', function () {
          var p = video.play();
          if (p !== undefined) p.then(markPlaying).catch(markPaused);
          else markPlaying();
        }, { once: true });
      }
    }

    video.addEventListener('play', markPlaying);
    video.addEventListener('pause', markPaused);

    if (audioBtn) {
      audioBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        if (video.muted) {
          audioBtn.classList.remove('is-unmuted');
        } else {
          audioBtn.classList.add('is-unmuted');
        }
      });
    }
  }

  /* ── Expand chevron (mobile tap to open panel) ── */
  function initExpandBtn(card) {
    var btn = card.querySelector('.vr-expand-btn');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      card.classList.toggle('panel-open');
    });
  }

  /* ── Panel close button ── */
  function initPanelClose(card) {
    var btn = card.querySelector('.vr-panel-close');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      card.classList.remove('panel-open');
    });
  }

  /* ── Variant selection ── */
  function initVariants(card) {
    var productItems = card.querySelectorAll('.vr-panel-product-item');
    productItems.forEach(function(item) {
      var variantBtns = item.querySelectorAll('.vr-variant-btn');
      var hiddenInput = item.querySelector('.vr-selected-variant');
      if (!variantBtns.length) return;

      variantBtns.forEach(function (vBtn) {
        vBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          variantBtns.forEach(function (b) { b.classList.remove('active'); });
          vBtn.classList.add('active');
          if (hiddenInput) {
            hiddenInput.value = vBtn.dataset.variantId;
            hiddenInput.dataset.available = vBtn.dataset.variantAvailable;
          }
        });
      });
    });
  }

  /* ── Add to cart (AJAX) Helper ── */
  function handleAddAjax(btn, items, isGroupBtn) {
    btn.classList.add('loading');
    btn.disabled = true;

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    var body = { items: items };
    if (sectionsToBundle.length) {
        body.sections = sectionsToBundle.join(',');
    }

    var config = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    };
    
    // Check if FoxTheme utils exist to append specific headers if necessary
    if (window.FoxTheme && window.FoxTheme.utils && window.FoxTheme.utils.fetchConfig) {
       config = { ...window.FoxTheme.utils.fetchConfig('javascript'), ...{ body: JSON.stringify(body) } };
    }

    fetch('/cart/add.js', config)
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function (parsedState) {
        btn.classList.remove('loading');
        btn.classList.add('success');
        if (isGroupBtn) btn.textContent = 'Added ✓';

        if (parsedState.sections && window.FoxTheme && window.FoxTheme.pubsub) {
           // We have sections, fetch the cart json to update the drawer state properly
           var fetchConfig = window.FoxTheme.utils && window.FoxTheme.utils.fetchConfig ? window.FoxTheme.utils.fetchConfig() : {};
           fetch('/cart.js', fetchConfig)
             .then(function(res) { return res.json(); })
             .then(function(cartJson) {
                cartJson.sections = parsedState.sections;
                window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
                
                // Show cart drawer explicitly
                var cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) cartDrawer.show();
             });
        } else {
           // Fallback to legacy refresh
           document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        }

        setTimeout(function () {
          btn.classList.remove('success');
          btn.disabled = false;
          if (isGroupBtn) btn.textContent = 'Add to cart';
        }, 2200);
      })
      .catch(function () {
        btn.classList.remove('loading');
        btn.disabled = false;
        if (isGroupBtn) {
          btn.textContent = 'Try again';
          setTimeout(function () { btn.textContent = 'Add to cart'; }, 2000);
        }
      });
  }

  /* ── Add to cart Init ── */
  function initAddToCart(card) {
    var btn = card.querySelector('.vr-add-all-btn');
    var itemBtns = card.querySelectorAll('.vr-item-add-btn');

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        var items = [];
        card.querySelectorAll('.vr-selected-variant').forEach(function(input) {
           if (input.dataset.available !== 'false' && input.value) {
              items.push({ id: parseInt(input.value, 10), quantity: 1 });
           }
        });

        if (items.length === 0) return;
        handleAddAjax(btn, items, true);
      });
    }

    itemBtns.forEach(function(itemBtn) {
      itemBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var itemContainer = itemBtn.closest('.vr-panel-product-item');
        var input = itemContainer.querySelector('.vr-selected-variant');
        var items = [];
        
        if (input && input.dataset.available !== 'false' && input.value) {
            items.push({ id: parseInt(input.value, 10), quantity: 1 });
        }

        if (items.length === 0) return;
        handleAddAjax(itemBtn, items, false);
      });
    });
  }

  /* ── Mini search → toggle panel ── */
  function initMiniSearch(card) {
    var btn = card.querySelector('.vr-mini-search');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      card.classList.toggle('panel-open');
    });
  }

  /* ════════════════════════════════════════════════════════
     SHOPIFY THEME EDITOR EVENTS
  ════════════════════════════════════════════════════════ */
  if (window.Shopify && Shopify.designMode) {

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.vr-section');
      if (section) initSection(section);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var section = e.target.closest('.vr-section');
      if (section) {
        section.classList.remove('vr-initialized');
        initSection(section);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('.swiper').forEach(function (el) {
        if (el._swiperInstance) {
          el._swiperInstance.destroy(true, true);
          el._swiperInstance = null;
        }
      });
    });
  }

  /* Homepage speed: section inserted later by snippets/lazy-section-loader */
  document.addEventListener('lazy-section:revealed', function (e) {
    var root = (e.detail && e.detail.container) || document;
    root.querySelectorAll('.vr-section').forEach(function (section) { initSection(section); });
  });

  /* ════════════════════════════════════════════════════════
     BOOT
  ════════════════════════════════════════════════════════ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

})();